
















import { Tab, Tabs } from 'vant';
import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import { namespace, State } from 'vuex-class';
import * as mutationTypes from './store/mutation-types';
import * as config from './config';

const Module = namespace('HealthContributionBrand2019');
Vue.use(Tab).use(Tabs);
@Component({
  components: {
    VoteList,
  },
})
export default class List extends Vue {
  @Module.Mutation(mutationTypes.CHANGE_LOADSTATUS_DATA)
  changeLoadstatus!: () => void;
  // action: string = '';
  options = config.OPTHINES;
  typeTitle = '';

  created() {
    this.changeLoadstatus();
    const filterArr = this.options.healthType.filter(
      (item) => (item.type as any) === this.$route.query.type,
    );
    // const index = (this.$route.query.type as any) - 1;
    // this.typeTitle = this.options.healthType[index as any].fullName;
    this.typeTitle = filterArr[0].fullName;
  }
}
